/**
 * Takes existing URL and reloads it to a new estimate by the given code.
 * @param estimateCode
 */
import { getSessionData, setSessionData } from './storageHelper';

import { LOCAL_STORAGE_KEY } from '~/core/constants';
import { RouteEnum } from '~/redux/slices/route/route.types';

export const alertWhenExiting = (e: Event) => {
  if (getIsDirtyState()) {
    e.preventDefault();
    e.returnValue = true; // required for chrome to alert
  }
};

/**
 * Set is dirty in local storage.
 */
export const setIsDirtyState = (value: boolean) => {
  setSessionData(LOCAL_STORAGE_KEY.IS_DIRTY, value);
};

export const getIsDirtyState = (): boolean => {
  const isDirty = getSessionData<boolean>(LOCAL_STORAGE_KEY.IS_DIRTY);

  return isDirty ?? false;
};

/**
 * Builds the URL that loads `estimateCode`, based on the URL currently open.
 * Kept pure (and exported) so the query/pathname rules can be asserted without
 * a real navigation — jsdom cannot intercept `document.location`.
 */
export const buildNewEstimateUrl = (
  currentHref: string,
  estimateCode: string,
  resetToRoot = false
): string => {
  const url = new URL(currentHref);

  if (resetToRoot) {
    url.pathname = RouteEnum.THANK_YOU;
  }
  url.searchParams.delete(LOCAL_STORAGE_KEY.LOAD_ESTIMATE);
  url.searchParams.append(LOCAL_STORAGE_KEY.LOAD_ESTIMATE, estimateCode);

  return url.toString();
};

export const gotoNewEstimate = (estimateCode: string, resetToRoot = false) => {
  setIsDirtyState(false);
  document.location.href = buildNewEstimateUrl(
    document.location.href,
    estimateCode,
    resetToRoot
  );
};
